import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=d866421c"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2713853479/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d866421c')) {
      api.createRecord('d866421c', component.options)
    } else {
      api.reload('d866421c', component.options)
    }
    module.hot.accept("./FilesView.vue?vue&type=template&id=d866421c", function () {
      api.rerender('d866421c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FilesView.vue"
export default component.exports